<template>
  <Form
    url="/renovacoes/config/planos-faixa/update"
    v-if="!loader"
    :plano="plano"
  />
</template>

<script>
import Form from "./Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-config-renovacoes-plano-update",
  data() {
    return {
      plano: {},
      loader: true
    };
  },
  components: {
    Form
  },
  methods: {
    async getPlanoFiaxa(id) {
      try {
        const { data } = await this.$http.post(
          "/renovacoes/config/planos-faixa/find",
          {
            id: id
          }
        );
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        const plano = await this.getPlanoFiaxa(id);

        if (!plano.id || plano == null) {
          return this.$toast.error("Registro não encontrado!");
        }

        this.plano = await plano;
        this.loader = false;
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Configurações de Renovação"
      }
    ]);
    this.getInit();
  }
};
</script>
